import enGB from "./messages/en-GB.json";
import es from "./messages/es.json";
import ptPT from "./messages/pt-PT.json";
import type { SupportedLocale } from "./locales";

export type Messages = typeof enGB;

export const MESSAGES: Record<SupportedLocale, Messages> = {
  "en-GB": enGB,
  es,
  "pt-PT": ptPT,
};

export function getMessages(locale: SupportedLocale): Messages {
  return MESSAGES[locale];
}
